import React, { memo } from "react";
import "./CheckInBanner.css";
import HeadingH1 from "../../utls/HeadingH1";
import FlightCheckInBannerImg from "../../images/BBTCheckIn.png";

const Banner = () => {
  const banner = {
    src: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/New%20Banners%20all%20pages/SEO_MEDIA/CheckInBanner.webp",
    heading: "Skip the Queue, Check-In Online!",
    subheading: "FLIGHT SOLUTIONS",
    text: "Enjoy hassle-free travel with quick and secure online check-in. Skip the line and head straight to your gate!",
    link: "/corporate-travel",
    buttonText: "DISCOVER MORE",
  };

  return (
    <div className="banner-section container-fluid p-0" style={{ minHeight: "80%" }}>
      <div className="single-banner position-relative w-100" style={{ height: "80%" }}>
        <picture>
          <source media="(max-width: 480px)" srcSet={`${banner.src}?w=480`} />
          <source media="(min-width: 481px)" srcSet={`${banner.src}?w=1200`} />
          <img
            src={banner.src}
            className="d-block w-100"
            alt={banner.subheading}
            loading="eager"
            fetchpriority="high"
            style={{ objectFit: "cover", height: "100%" }}
          />
        </picture>
        <div className="carousel-caption bannercarousel text-white mt-xxl-5 pt-xxl-3 mt-1">
          <p className="grotesk-headings mb-1">{banner.subheading}</p>
          <HeadingH1 className="banner-headings w-100">{banner.heading}</HeadingH1>
          <div className="d-flex common-second-content">
            <div className="ornge-border"></div>
            <div className="second-content mt-2">{banner.text}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Banner);
